import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const ListingCounter = styled.div`
  display: flex;
  align-items: center;
  padding: 21px 0px;
  font-size: 12px;
  max-width: 700px;
  height: 70px;
`;

export const ListingCounterSort = styled.div(
  ({ theme: { PRIMARY } }) => css`
    color: ${PRIMARY};
    font-weight: 500;
    &:hover {
      text-decoration: underline;
    }
  `
);

export const ListingCounterCount = styled.p(
  ({ theme: { PRIMARY } }) => css`
    color: ${PRIMARY};
    font-weight: 500;
    padding: 0px 24px 0px 4px;
    width: 100px;
  `
);
